// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Import Wizard Stepper ─────────────────────────────────────────────── */
.import-stepper {
  position: relative;
  padding: 0 1rem;
}

/* Horizontal track line behind the circles */
.import-stepper__track {
  position: absolute;
  top: 20px;
  left: calc(12.5% + 20px);
  right: calc(12.5% + 20px);
  height: 4px;
  background-color: #dee2e6;
  border-radius: 2px;
  z-index: 0;
}

/* Filled portion of the track */
.import-stepper__fill {
  height: 100%;
  background-color: var(--bs-primary, #0d6efd);
  border-radius: 2px;
  transition: width 0.4s ease;
}

/* Flex row of step nodes */
.import-stepper__steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

/* Individual step node */
.import-stepper__step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

/* Circle */
.import-stepper__circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #dee2e6;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.95rem;
  border: 3px solid #dee2e6;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
}

/* Active step */
.import-stepper__step.is-active .import-stepper__circle {
  background-color: var(--bs-primary, #0d6efd);
  border-color: var(--bs-primary, #0d6efd);
  color: #fff;
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.2);
}

/* Completed step */
.import-stepper__step.is-complete .import-stepper__circle {
  background-color: var(--bs-success, #198754);
  border-color: var(--bs-success, #198754);
  color: #fff;
}

/* Label */
.import-stepper__label {
  margin-top: 6px;
  font-size: 0.78rem;
  font-weight: 500;
  color: #6c757d;
  text-align: center;
  white-space: nowrap;
}

.import-stepper__step.is-active .import-stepper__label {
  color: var(--bs-primary, #0d6efd);
  font-weight: 700;
}

.import-stepper__step.is-complete .import-stepper__label {
  color: var(--bs-success, #198754);
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
